<template>
	<div class="inf-widget">
		<slot></slot>
	</div>
</template>

<style>
.inf-widget {
	padding: 1.25rem;
	margin-top: 1.25rem;
	margin-bottom: 1.25rem;
	border: 1px solid #eee;
	border-left-width: .25rem;
	border-left-color: #1e293d;
	background: #fff;
	font-size: 16px;
}
.inf-widget p:last-child {
	margin-bottom: 0;
}
</style>